import { MoonLoader } from 'react-spinners';

import Input from 'components/input/input';
import Select from 'components/select/select';
import FileUpload from 'components/upload/upload';

import { INTELLIO_SPECIALTIES, TYPES } from 'config/doctor';
import { COUNTRIES } from 'config/country';

const ViewComponent = ({
  doctor,
  loading,
  onChange,
  onSelectChange,
  onFileUpload,
  onTariffChange,
  onKeyDown,
  validation,
  standardTC,
  eveningTC,
  saturdayTC,
  sundayHolidayTC,
}) => {
  return (
    <>
      <div>
        <h4 className="midlightgrey f-small fw5 ttu mt15">Details</h4>
        <div className="pa5 pt4 br4 shadow-1 bg-grouped-table mt2 flex flex-column items-start justify-between">
          <div className="w-100 flex flex-column">
            <div className="w-100 flex flex-row items-start justify-between margin-between">
              <div className="w-66">
                <div className="w-100 flex flex-row justify-between margin-between">
                  <div className="w-50">
                    <Input
                      name="firstName"
                      label="First name*"
                      value={doctor.firstName}
                      valid={validation.firstName}
                      onChange={(event) => onChange(event)}
                    />
                  </div>
                  <div className="w-50">
                    <Input
                      name="lastName"
                      label="Last name*"
                      value={doctor.lastName}
                      valid={validation.lastName}
                      onChange={(event) => onChange(event)}
                    />
                  </div>
                </div>
                <div className="w-100 flex flex-row justify-between margin-between">
                  <div className="w-50">
                    <Input
                      name="email"
                      label="Email*"
                      value={doctor.email}
                      valid={validation.email}
                      onChange={(event) => onChange(event)}
                    />
                  </div>
                  <div className="w-50">
                    <Select
                      className="type-select"
                      valid={validation.type}
                      isMulti={false}
                      label="Account type*"
                      value={doctor.type}
                      options={TYPES}
                      onChange={(selectedOption) =>
                        onSelectChange('type', selectedOption)
                      }
                    />
                  </div>
                </div>
                <div className="w-100 flex flex-row justify-between margin-between">
                  <div className="w-50">
                    <Select
                      className="country-select"
                      valid={true}
                      isMulti={false}
                      label="Select country"
                      value={doctor.country}
                      options={COUNTRIES}
                      onChange={(selectedOption) =>
                        onSelectChange('country', selectedOption)
                      }
                    />
                  </div>
                  <div className="w-50">
                    <Input
                      name="city"
                      label="City"
                      value={doctor.city}
                      valid={true}
                      onChange={(event) => onChange(event)}
                    />
                  </div>
                </div>
                <div className="w-100 flex flex-row justify-between margin-between">
                  <Input
                    name="address"
                    label="Address"
                    value={doctor.address}
                    valid={true}
                    onChange={(event) => onChange(event)}
                  />
                </div>
                <div className="w-100 flex flex-row justify-between margin-between">
                  <div className="w-50">
                    <Input
                      name="rpps"
                      label="RPPS"
                      value={doctor.rpps}
                      valid={true}
                      onChange={(event) => onChange(event)}
                    />
                  </div>
                  <div className="w-50">
                    <Input
                      name="finesId"
                      label="Fines ID"
                      value={doctor.finesId}
                      valid={true}
                      onChange={(event) => onChange(event)}
                    />
                  </div>
                </div>
                <div className="w-100 flex flex-row justify-between margin-between">
                  <div className="w-50">
                    <Select
                      className="specialty-select"
                      valid={true}
                      isMulti={false}
                      label="Select specialty"
                      value={doctor.specialty}
                      options={INTELLIO_SPECIALTIES}
                      onChange={(selectedOption) =>
                        onSelectChange('specialty', selectedOption)
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="w-32">
                {loading ? (
                  <div
                    className="flex flex-column justify-center items-center"
                    style={{ height: '298px' }}
                  >
                    <MoonLoader color="#455d7a" size={60} />
                  </div>
                ) : (
                  <FileUpload
                    className="avatar-upload"
                    name="avatar"
                    label="Avatar"
                    accept="image/*"
                    value={doctor.avatarUrl}
                    valid={true}
                    onFileUpload={(file) => onFileUpload(file[0])}
                  />
                )}
              </div>
            </div>
            <div className="w-100 flex flex-row items-start justify-between margin-between">
              <div className="w-66"> </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <h4 className="midlightgrey f-small fw5 ttu mt15">Contact info</h4>
        <div className="pa5 pt4 br4 shadow-1 bg-grouped-table mt2 flex flex-column items-start justify-between">
          <div className="w-100 flex flex-column">
            <div className="w-100 flex flex-row items-start justify-between margin-between">
              <div className="w-50">
                <Input
                  name="phone"
                  label="Phone number"
                  value={doctor.phone}
                  valid={true}
                  onChange={(event) => onChange(event)}
                />
              </div>
              <div className="w-50">
                <Input
                  name="personalEmail"
                  label="Personal email"
                  value={doctor.personalEmail}
                  valid={true}
                  onChange={(event) => onChange(event)}
                />
              </div>
            </div>
            <div className="w-100 flex flex-row items-start justify-between margin-between">
              <div className="w-66"> </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <h4 className="midlightgrey f-small fw5 ttu mt15">Links</h4>
        <div className="pa5 pt4 br4 shadow-1 bg-grouped-table mt2 flex flex-column items-start justify-between">
          <div className="w-100 flex flex-column">
            <div className="w-100 flex flex-row items-start justify-between margin-between">
              <div className="w-33">
                <Input
                  name="calendlyUrl"
                  label="Calendly link"
                  value={doctor.calendlyUrl}
                  valid={true}
                  onChange={(event) => onChange(event)}
                />
              </div>
              <div className="w-33">
                <Input
                  name="teleconsultationRoomUrl"
                  label="Teleconsultation room"
                  value={doctor.teleconsultationRoomUrl}
                  valid={true}
                  onChange={(event) => onChange(event)}
                />
              </div>
              <div className="w-33">
                <Input
                  name="stripeUrl"
                  label="Stripe link"
                  value={doctor.stripeUrl}
                  valid={true}
                  onChange={(event) => onChange(event)}
                />
              </div>
            </div>
            <div className="w-100 flex flex-row items-start justify-between margin-between">
              <div className="w-66"> </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <h4 className="midlightgrey f-small fw5 ttu mt15">Tariffs</h4>
        <div className="pa5 pt4 br4 shadow-1 bg-grouped-table mt2 flex flex-column items-start justify-between">
          <div className="w-100 flex flex-column">
            <div className="w-100 flex flex-row items-start justify-between margin-between">
              <div className="w-50">
                <Input
                  name="standardTC"
                  label={`${standardTC.name}: ${standardTC.rules}`}
                  type="number"
                  value={standardTC.amount}
                  placeholder="0.00"
                  valid={true}
                  withCurrency={true}
                  onChange={(event) => onTariffChange(event)}
                  onKeyDown={(event) => onKeyDown(event)}
                />
                <Input
                  name="eveningTC"
                  label={`${eveningTC.name}: ${eveningTC.rules}`}
                  value={eveningTC.amount}
                  type="number"
                  placeholder="0.00"
                  valid={true}
                  withCurrency={true}
                  onChange={(event) => onTariffChange(event)}
                  onKeyDown={(event) => onKeyDown(event)}
                />
              </div>
              <div className="w-50">
                <Input
                  name="saturdayTC"
                  label={`${saturdayTC.name}: ${saturdayTC.rules}`}
                  value={saturdayTC.amount}
                  type="number"
                  placeholder="0.00"
                  valid={true}
                  withCurrency={true}
                  onChange={(event) => onTariffChange(event)}
                  onKeyDown={(event) => onKeyDown(event)}
                />
                <Input
                  name="sundayHolidayTC"
                  label={`${sundayHolidayTC.name}: ${sundayHolidayTC.rules}`}
                  type="number"
                  value={sundayHolidayTC.amount}
                  placeholder="0.00"
                  valid={true}
                  withCurrency={true}
                  onChange={(event) => onTariffChange(event)}
                  onKeyDown={(event) => onKeyDown(event)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewComponent;
